import { proformApiQuery } from '@eliadmin/core/src/api/proform/proform-api';
import { useQuery } from '@tanstack/react-query';

// Plain useQuery on purpose: product detail tabs have no Suspense boundary, so a suspending
// query there discards the uncommitted QueryClient on every retry and refetches in a loop.
export function useEliProductDetails(cislo_nomenklatury: string) {
  return useQuery({
    queryKey: ['ELI_GET_PRODUCT', { cislo_nomenklatury }],
    queryFn: async () => {
      return proformApiQuery('ELI_GET_PRODUCT', {
        cislo_nomenklatury,
        id_shop: 3,
      });
    },
    enabled: Boolean(cislo_nomenklatury),
    retry: false,
    throwOnError: false,
  });
}
